import * as _ from 'lodash';
import baseRequest from './baseRequest';
import { utils } from 'ui-common';
import { AcceptedTermsTypes } from 'login-components/Common/Inputs/RequirementInput/utils';

const { featureFlags } = utils;

const JOURNEY_CHOOSER_SUBMIT_URL = '/api/login-ui/journey-chooser';

export async function journeyChooserSubmit(values, consents: AcceptedTermsTypes[]) {
  const formValues: { [key: string]: any } = _.pick(
    values,
    'phoneNumber',
    'propertySearchType',
    'loanPurpose',
    'giveConsentToLenderContact',
  );

  // a double check on whether or not the user has actually checked the box to confirm they consent to the consents
  // specified in the journey chooser. If the feature flag is on, there is no box to check or redux value to update,
  // so we check the equivalent redux value instead
  const userGaveConsent =
    !!values.acceptTermsAndConditions ||
    (featureFlags.isEnabled('requireViewingTermsBeforeAccepting20190904') && values.userViewedTermsAndConditionsText);

  let modelProperties = {
    homePhone: formValues.phoneNumber,
    consentToLenderContactGiven: formValues.giveConsentToLenderContact,
    propertySearchType: formValues.propertySearchType,
    loanPurpose: formValues.loanPurpose,
    econsentGiven: userGaveConsent && _.includes(consents, 'eConsent'),
    voiConsentGiven: userGaveConsent && _.includes(consents, 'creditConsent'),
    creditConsentGiven: userGaveConsent && _.includes(consents, 'creditConsent'),
  };

  // propertySearchType may be null if loanPurpose is REFINANCE; don't send it to the api if so
  if (modelProperties.propertySearchType === null) {
    modelProperties = _.omit(modelProperties, 'propertySearchType');
  }

  return await baseRequest.post(JOURNEY_CHOOSER_SUBMIT_URL, {
    modelProperties,
    acceptTerms: userGaveConsent && _.includes(consents, 'termsOfUse'),
  });
}
